<script setup>
defineProps({
    active: Boolean,
    title: String,
    description: String,
    icon: String
})
</script>

<template>
    <div class="flex p-4 rounded-lg border relative bg-white dark:bg-neutral-900 dark:border-neutral-700 dark:text-white gap-2 text-gray-500 overflow-hidden hover:text-gray-800 dark:hover:text-gray-200 hover:shadow-lg transition-all cursor-pointer shadow w-1/2"
        :class="active ? 'ring-2 ring-offset-1' : ''"
    >

        <i :class="icon" class="mt-0.5 text-roori-blue"></i>
        <div>
            <p class="font-bold">{{ title }}</p>
            <p class="font-normal text-sm opacity-70">{{ description }}</p>
        </div>
        <Transition name="scale">
            <div v-if="active" class="absolute w-full h-full backdrop-blur-lg top-0 flex justify-center items-center gap-2 left-0">
                <i class="pi pi-save !text-xl -mt-5 text-roori-blue"></i>
                <div>
                    <p class="font-bold">{{ $t('common.editing') }}</p>
                    <p class="text-sm">{{ $t('forms.close_panel_hint') }}</p>
                </div>
            </div>
        </Transition>
    </div>
</template>

<style scoped lang="scss">
</style>
